export default __webpack_public_path__ + "static/media/marcel-duchamp.f8aa6d3d.jpg";